/**
 * V112-3-10 (built-panel flow Blocker): one unsaved-changes guard for every way off a scope screen.
 *
 * The save bar registers a handler while it has unsaved edits. Anything that leaves without a link (the system
 * page's tab buttons) runs its move through `guarded()`: with no edits it runs at once; with edits the save bar asks
 * first (Review changes / Discard and leave / Stay) and runs it only on "Discard and leave".
 */
type Handler = (go: () => void) => void;
let handler: Handler | null = null;

export function setScopeGuard(h: Handler | null): void { handler = h; }

/** Run `go` now, or after the person confirms leaving their unsaved scope edits. */
export function guarded(go: () => void): void {
  if (handler) handler(go);
  else go();
}
